module.exports = __webpack_public_path__ + "img/AW.bca16d6b.svg";